/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./recommendations.defs.js";
export { main as default } from "./recommendations.defs.js";
